module.exports = __webpack_public_path__ + "static/media/11_plantilla_menu_fondo_rojo.7ec1c1f9.png";